<template>
  <div id="app" style="padding-top: 70px;">
    <div data-v-f72f4208="" class="layout">
      <div data-v-2b6ea562="" data-v-f72f4208="" class="sticky">
        <div class="logo" style="width: 90px;height: 30px;background-image: url('./static/logo.png');background-size: 100% 100%;
                              margin-right: 50px;position: absolute;top:22px;left: 10px;">
        </div>
        <div data-v-2b6ea562="" class="top-mask">
          <header data-v-2b6ea562="" class="top container">
            <div data-v-2b6ea562="" class="left">
            </div>
          </header>
        </div>
        <div data-v-4c6d260d="" data-v-2b6ea562="" class="overlay" style="z-index: 99999; display: none;">
          <div data-v-2b6ea562="" class="wrapper">
            <!---->
          </div>
        </div>
      </div>
      <div data-v-f72f4208="" class="main-content">
        <section data-v-b9f1e512="" data-v-f72f4208="" class="requirement-publish">
          <div data-v-b9f1e512="" class="steps container">
            <div data-v-b9f1e512="" class="el-steps el-steps--horizontal">
              <div data-v-b9f1e512="" class="el-step is-horizontal is-center"
                style="flex-basis: 33.3333%; margin-right: 0px;">
                <div class="el-step__head is-process">
                  <div class="el-step__line" style="margin-right: 0px;">
                    <i class="el-step__line-inner" style="transition-delay: 0ms; border-width: 0px; width: 0%;"></i>
                  </div>
                  <div class="el-step__icon is-text">
                    <!---->
                    <div class="el-step__icon-inner">
                      1
                    </div>
                  </div>
                </div>
                <div class="el-step__main">
                  <div class="el-step__title is-process">
                    填写身份信息
                  </div>
                  <div class="el-step__description is-process"></div>
                </div>
              </div>
              <div data-v-b9f1e512="" class="el-step is-horizontal is-center"
                style="flex-basis: 33.3333%; margin-right: 0px;">
                <div class="el-step__head is-wait">
                  <div class="el-step__line" style="margin-right: 0px;">
                    <i class="el-step__line-inner" style="transition-delay: -150ms; border-width: 0px; width: 0%;"></i>
                  </div>
                  <div class="el-step__icon is-text">
                    <!---->
                    <div class="el-step__icon-inner">
                      2
                    </div>
                  </div>
                </div>
                <div class="el-step__main">
                  <div class="el-step__title is-wait">
                    提交申请
                  </div>
                  <div class="el-step__description is-wait"></div>
                </div>
              </div>
              <div data-v-b9f1e512="" class="el-step is-horizontal is-center"
                style="flex-basis: 33.3333%; max-width: 33.3333%;">
                <div class="el-step__head is-wait">
                  <div class="el-step__line">
                    <i class="el-step__line-inner"></i>
                  </div>
                  <div class="el-step__icon is-text">
                    <!---->
                    <div class="el-step__icon-inner">
                      3
                    </div>
                  </div>
                </div>
                <div class="el-step__main">
                  <div class="el-step__title is-wait">
                    提交审核
                  </div>
                  <div class="el-step__description is-wait"></div>
                </div>
              </div>
            </div>
          </div>
          <div data-v-b9f1e512="" class="step-content step1 container ">
            <div data-v-404dca0e="" data-v-b9f1e512="">
              <div data-v-404dca0e="" class="title">
                <div data-v-404dca0e="">
                  申请创意设计师创客认证
                </div>
                <div data-v-404dca0e="" class="intro">
                  请您填写一下信息，我们将在7个工作日内完成审核
                </div>
              </div>
              <div data-v-404dca0e="" class="line"></div>
              <form data-v-404dca0e="" class="el-form form">
                <div data-v-404dca0e="" class="">
                  <label for="directionList" class="" style="width: 100px;margin-bottom: 30px;">
                    主要方向
                  </label>
                  <el-checkbox-group v-model="checkList">
                    <el-checkbox label="UI"></el-checkbox>
                    <el-checkbox label="品牌设计"></el-checkbox>
                    <el-checkbox label="绘画"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <div data-v-404dca0e="" class="">
                  <label for="directionList" class="" style="width: 100px;margin-bottom: 30px;">
                    擅长类型
                  </label>
                  <el-checkbox-group v-model="value2">
                    <el-checkbox :label="item" v-for="(item, index) in label2" :key="index"></el-checkbox>
                  </el-checkbox-group>
                </div>
                <div data-v-404dca0e="" class="">
                  <label for="directionList" class="" style="width: 100px;margin-bottom: 30px;">
                    风格元素
                  </label>
                  <el-checkbox-group v-model="value3">
                    <el-checkbox :label="item" v-for="(item, index) in label3" :key="index"></el-checkbox>
                  </el-checkbox-group>
                </div>
              </form>
              <div class="submit">
                <el-button type="primary" @click="btn">提交申请</el-button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
    <!---->
    <div data-v-2b2bc979="">
      <div data-v-2b2bc979="" class="chat-box">
      </div>
      <div data-v-2b2bc979="" class="chat-box-mask" style="display: none;"></div>
    </div>
  </div>
</template>

<script>
import { userCheckApi } from "../api/index";
export default {
  data() {
    return {
      checkList: ['UI'],
      label2: [
        "网站/网页",
        "游戏UI",
        "APP",
        "H5",
        "Banner",
        "主题皮肤",
        "电子屏",
        "Icon",
        "专题页"
      ],
      value2: ["网站/网页"],
      label3: [
        "简笔",
        "水彩",
        "场景",
        "古风",
        "肌理",
        "扁平化",
        "抽象",
        "写实",
        "Q版",
        "二次元",
        "国潮",
        "水墨",
        "日系",
        "韩系",
        "欧系",
        "卡通",
        "涂鸦",
        "赛博朋克",
        "波普",
        "人物角色",
        "精灵妖兽",
        "机械怪物",
        "吉祥物",
        "风景",
        "楼兰建筑",
        "科幻未来",
        "MBE",
        "像素",
        "矢量2.5D",
        "3D",
        "Erics",
        "极简艺术",
        "古典",
        "现代",
        "低面建模",
        "孟菲斯风格",
        "蒸汽朋克",
        "极繁风格",
        "立体主义",
        "超写实",
        "重工业",
        "哥特",
        "电商"
      ],
      value3: ["简笔"],
    }
  },
  methods: {
    async btn() {
      const res = await userCheckApi()
      if(res.data.code===0){
        this.$router.push('/display')
        this.$message({
          message: res.data.msg,
        });
      }
      if(res.code===200){
        this.$router.push('/display')
        this.$message({
          message: '提交成功，待审核',
          type: 'success'
        });
      }
    },
    
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/css/chunk-dce1acd6.e29ae1a4.css';
// @import '../assets/css/app.8f4874e9.css';
.submit{
  display: flex;
  justify-content: center;
}
</style>
